import { wrapRunner } from './util.js';
/**
 * Single instance runner, that immediately gives up if another function is already running
 */
export class SingleInstanceRunner {
    #running = false;
    /**
     * If the runner is currently running a function
     */
    get running() {
        return this.#running;
    }
    async run(fn) {
        if (this.#running)
            throw new Error('Already running');
        this.#running = true;
        return await fn().finally(() => {
            this.#running = false;
        });
    }
    /**
     * Wrap a function to make sure only one instance is running at a time
     */
    wrap(fn) {
        return wrapRunner(fn, this);
    }
    /**
     * Wrap a function to make sure only one instance is running at a time
     */
    static wrap(fn) {
        return new SingleInstanceRunner().wrap(fn);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2luZ2xlSW5zdGFuY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvc2luZ2xlSW5zdGFuY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLFdBQVcsQ0FBQTtBQUV0Qzs7R0FFRztBQUNILE1BQU0sT0FBTyxvQkFBb0I7SUFDaEMsUUFBUSxHQUFHLEtBQUssQ0FBQTtJQUVoQjs7T0FFRztJQUNILElBQUksT0FBTztRQUNWLE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQTtJQUNyQixDQUFDO0lBRUQsS0FBSyxDQUFDLEdBQUcsQ0FBSSxFQUFvQjtRQUNoQyxJQUFJLElBQUksQ0FBQyxRQUFRO1lBQUUsTUFBTSxJQUFJLEtBQUssQ0FBQyxpQkFBaUIsQ0FBQyxDQUFBO1FBQ3JELElBQUksQ0FBQyxRQUFRLEdBQUcsSUFBSSxDQUFBO1FBQ3BCLE9BQU8sTUFBTSxFQUFFLEVBQUUsQ0FBQyxPQUFPLENBQUMsR0FBRyxFQUFFO1lBQzlCLElBQUksQ0FBQyxRQUFRLEdBQUcsS0FBSyxDQUFBO1FBQ3RCLENBQUMsQ0FBQyxDQUFBO0lBQ0gsQ0FBQztJQUVEOztPQUVHO0lBQ0gsSUFBSSxDQUNILEVBQThCO1FBRTlCLE9BQU8sVUFBVSxDQUFDLEVBQUUsRUFBRSxJQUFJLENBQUMsQ0FBQTtJQUM1QixDQUFDO0lBRUQ7O09BRUc7SUFDSCxNQUFNLENBQUMsSUFBSSxDQUNWLEVBQThCO1FBRTlCLE9BQU8sSUFBSSxvQkFBb0IsRUFBRSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQTtJQUMzQyxDQUFDO0NBQ0QifQ==